#### New URLs for Apply with SEEK button assets

If you currently enforce strict [Content Security Policy (CSP)](https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/CSP) on image assets for [Apply with SEEK](/use-cases/apply-with-seek/display-button#content-security-policy-compatibility), be aware that there will be a change to this URL.

**Why is this changing?**

The SEEK API will provide a single base URL for static assets that your software can include in its CSP.
As we introduce new solutions that rely on static assets, this will speed up builds and remove the need to repeatedly revise your CSP.

**What is changing?**

From March 31, 2026, Apply with SEEK button assets will move from `https://integration.seek.com/awsk/*` to `https://integration.seek.com/assets/*`.

**What change is required for partners?**

If your software dynamically retrieves button images from the [`applyWithSeekButton` query](/use-cases/apply-with-seek/display-button), it will pick up the new URLs automatically.
Review if it enforces a strict CSP per our [documented guidance](/use-cases/apply-with-seek/display-button#content-security-policy-compatibility), and where applicable, update the following directive to load image assets from our new URLs:

```diff
Content-Security-Policy:
  connect-src 'self' *.seek.com;
  font-src 'self' https://*.seek.com;
- img-src 'self' https://image-service-cdn.seek.com.au https://integration.seek.com/awsk/button-assets/;
+ img-src 'self' https://*.seek.com https://*.seek.com.au;
  script-src 'self' https://integration.seek.com;
  style-src 'self' https://*.seek.com;
```

If your software hardcodes button image retrieval from SEEK (i.e. `<img src="https://integration.seek.com/awsk/button-assets/button-images/seek/en/small-accent.svg" />`), contact us.
Your integration is non-compliant, and while we will maintain backward compatibility with existing URLs in this instance, it may be impacted by future changes.

No change is required for partners that do not enforce a strict CSP.
